import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { SegmentedControl } from './SegmentedControl';
import { mockDataVolumeStore, type MockVolume } from '../../services/mock/mockDataVolume';

/**
 * MockDataSwitch — the dev-only "0 / Some / Huge" mock-data volume control.
 *
 * Renders ONLY on the Sales Intelligence tab and ONLY for superadmin-labelled
 * users (the caller gates visibility). Bound to the localStorage-backed volume
 * store, so the choice survives reloads and live-updates every mock consumer
 * (n8nServiceMock + the Sales UniBox api) without a page reload.
 *
 * Pure presentational glue over SegmentedControl + the volume store.
 */
export const MockDataSwitch: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [volume, setVolumeState] = useState<MockVolume>(mockDataVolumeStore.getVolume());

  useEffect(() => mockDataVolumeStore.subscribe(setVolumeState), []);

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`.trim()}>
      <div className="inline-flex items-center gap-1.5 rounded-full border border-amber-300/18 bg-amber-400/8 px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-amber-100 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
        <Icon icon="bx:flask" className="h-3.5 w-3.5 text-amber-200/90" />
        Mock data
      </div>
      <SegmentedControl
        ariaLabel="Mock data volume"
        size="sm"
        tone="accent"
        value={volume}
        onChange={(next) => mockDataVolumeStore.setVolume(next as MockVolume)}
        options={[
          { value: 'none', icon: 'bx:data', label: '0' },
          { value: 'some', icon: 'bx:layer', label: 'Some' },
          { value: 'huge', icon: 'bx:layers', label: 'Huge' },
        ]}
      />
    </div>
  );
};

export default MockDataSwitch;
